import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = {
  for: "amount",
  class: "col-sm-4 col-form-label text-capitalize-first pe-2"
}
const _hoisted_3 = { class: "col-sm-4" }
const _hoisted_4 = { class: "col-sm-2 col-form-label ms-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: _ctx.helper.trans('labels.deal_action_confirmation', {action: _ctx.helper.trans(`deals.action.confirm`)}),
    modelValue: _ctx.modal !== null,
    "footer-class": "d-flex justify-content-between",
    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ($event === false && (_ctx.modal = null)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.helper.trans("labels.sum")), 1),
        _createElementVNode("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.amount) = $event)),
            "data-maska": "9.##",
            "data-maska-tokens": "9:[0-9]:multiple",
            type: "text",
            class: "form-control",
            name: "amount"
          }, null, 512), [
            [_vModelText, _ctx.form.amount],
            [_directive_maska]
          ])
        ]),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.modal?.deal.takerSum.currency), 1)
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modal = null)),
        class: "btn btn-outline-dark btn-sm text-capitalize-first"
      }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
      _createVNode(_component_LoaderWrapper, {
        ref: "loader",
        zoom: 0.5
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onOkClick())),
            class: "btn btn-outline-danger btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.helper.trans(`deals.action.confirm`)), 1)
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}